import { createApiClient } from "../../../packages/admin-ui/src/index";

// VITE_API_BASE is injected at build time. Defaults to a same-origin "/api" path so a
// Pages Functions / Worker route can proxy without CORS in production.
const baseUrl = (import.meta.env.VITE_API_BASE as string | undefined) ?? "/api";

export const api = createApiClient({ baseUrl });
